export function MessageTypeConfig() {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-violet-200 dark:border-violet-500/30 bg-violet-50 dark:bg-violet-500/10 p-3 text-xs text-violet-800 dark:text-violet-200">
        Este nó identifica automaticamente o tipo da mensagem recebida e roteia por saída:
        <strong> text</strong>, <strong>image</strong>, <strong>audio</strong> ou <strong>default</strong>.
      </div>
      <p className="text-xs text-slate-500 dark:text-slate-300">
        Não é necessário configurar variáveis manualmente. O sistema usa automaticamente o conteúdo recebido do Bitrix e grava o resultado em <strong>message_type</strong>.
      </p>
    </div>
  );
}
